import type { VideoPreparationImage } from '@ngsos/portal-core/video';

import { VIDEO_GUIDANCE_IMAGES } from './videoGuidanceImages';

const DIMENSIONS = {
  appleEedShare: { width: 600, height: 1050 },
  googleElsShare: { width: 600, height: 1013 },
  webAppSms: { width: 600, height: 1050 },
  webAppCamera: { width: 600, height: 1050 },
  webAppLocation: { width: 600, height: 1050 },
} satisfies Record<VideoPreparationImage, { width: number; height: number }>;

export function getVideoGuidanceImage(image: VideoPreparationImage, language: string) {
  const locale = language.toLowerCase();
  const baseLanguage = locale.split('-')[0] ?? 'en';
  const images = VIDEO_GUIDANCE_IMAGES[locale]
    ?? VIDEO_GUIDANCE_IMAGES[baseLanguage]
    ?? VIDEO_GUIDANCE_IMAGES.en;
  const source = images[image] ?? VIDEO_GUIDANCE_IMAGES.en[image];

  return { source, ...DIMENSIONS[image] };
}
